import { isDesignStudioInIframe } from './isDesignStudioInIframe';

const isIframeFullscreen = (): boolean => {
  if (isDesignStudioInIframe()) {
    try {
      const iframeIsFullscreen =
        !!document.fullscreenElement ||
        // @ts-ignore
        !!document.mozFullScreenElement ||
        // @ts-ignore
        !!document.webkitFullscreenElement;
      return iframeIsFullscreen;
    } catch (error) {
      return false;
    }
  }
  return false;
};
export { isIframeFullscreen };
